import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import { getTwoDecimalPlaces } from "../../../utils";
const columns = [
  {
    label: "Particulars",
    className: "table-width-20",
    columnName: "particulars",
  },
  {
    label: "Pre tax",
    className: "table-width-20",
    columnName: "preTax",
  },
  {
    label: "Roth",
    className: "table-width-20",
    columnName: "roth",
  },
  {
    label: "Employer Match",
    className: "table-width-20",
    columnName: "employerMatch",
  },
  {
    label: "Total",
    className: "table-width-20",
    columnName: "total",
  },
];
const data = [
  {
    particulars: "Employer Contribution Account",
    preTax: 340123,
    roth: 102123,
    employerMatch: 442246,
    total: 1232432,
  },
  {
    particulars: "Employer Contribution - Vested A/C",
    preTax: 340123,
    roth: 102123,
    employerMatch: 442246,
    total: 1232432,
  },
  {
    particulars: "Employer Contribution - Unvested A/C",
    preTax: 340123,
    roth: 102123,
    employerMatch: 442246,
    total: 1232432,
  },
];
const total = {
  particulars: "Total",
  preTax: 340123,
  roth: 102123,
  employerMatch: 442246,
  total: 1232432,
};
export const SourceLevelInvestmentTable = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className={e.className}>{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {total[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(total[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
      </Table.Tbody>
    </Table>
  );
};
